<style lang="less" scoped>
  .main-container {
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
</style>

<template lang="pug">
  .main-container
    header-component(:title="title")
    router-view
</template>

<script>
import { mapState } from 'vuex';
import headerComponent from '@/components/header';

export default {
  components: {
    headerComponent,
  },
  computed: {
    ...mapState({
      title: state => state.app.title,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/index.vue